/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ zalo_error: NonNullable<unknown> }} Error_Zalo_Api_ErrorInputs */

const vi_error_zalo_api_error = /** @type {(inputs: Error_Zalo_Api_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zalo trả lỗi ${i?.zalo_error}. Vui lòng thử lại sau ít phút.`)
};

/**

* @param {Error_Zalo_Api_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zalo_api_error = /** @type {((inputs: Error_Zalo_Api_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zalo_Api_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zalo_api_error(inputs)
});